<template>
  <v-fade-transition>
    <v-overlay
      
      absolute
      color="#FFFFFF"
    >
      <v-progress-circular
        :size="70"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-overlay>
  </v-fade-transition>
</template>

<script>
  export default {
    props:{
    },
    data: () => ({
    }),
  }
</script>

<style lang="css" scoped>

</style>